import * as api from "../Api";

// create a  new asset
export const getRevaluedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getRevaluedAsset();
    dispatch({ type: "FETCH_ALL_REVALUE_ASSET", payload: data });
  } catch (error) {}
};

export const revalueAsset = (postData, id) => async (dispatch) => {
  try {
    const { data } = await api.revaluateAsset(postData, id);
    dispatch({ type: "REVALUATE_ASSET", payload: data });
  } catch (error) {}
};
